'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.toAbsoluteUrl = toAbsoluteUrl;
exports.extractIdFromHateoasHref = extractIdFromHateoasHref;
exports.extractIdFromHateoasModel = extractIdFromHateoasModel;
exports.extractRelationsLinks = extractRelationsLinks;
exports.extractNotFetchedLinks = extractNotFetchedLinks;
exports.extractModelTypeFromHateoasModel = extractModelTypeFromHateoasModel;
exports.normalizeModel = normalizeModel;
exports.normalizeModels = normalizeModels;
exports.convertModel2Json = convertModel2Json;
exports.promise2jqueryPromise = promise2jqueryPromise;
exports.checkHttpCode = checkHttpCode;
exports.always = always;

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _bluebird = require('bluebird');

var _nestedUtils = require('./nestedUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toAbsoluteUrl(baseUrl, url) {
    if (url.startsWith('http')) {
        return url;
    }

    var normalizedUrl = url;
    if (url.startsWith('/')) {
        normalizedUrl = url.substr(1, url.length);
    }

    return baseUrl + normalizedUrl;
}

function extractCollectionNameFromEmbedded(hateoasResponse) {
    return _underscore2.default.keys(hateoasResponse._embedded)[0];
}

function extractCollectionFromEmbedded(hateoasResponse) {
    if (hateoasResponse._embedded) {
        var collectionName = extractCollectionNameFromEmbedded(hateoasResponse);
        return hateoasResponse._embedded[collectionName];
    }
    return [];
}

function extractIdFromHateoasHref(hateoasHref) {
    return hateoasHref.substring(hateoasHref.lastIndexOf('/') + 1);
}

function extractModelTypeFromHateoasHref(hateoasHref) {
    var href = hateoasHref.substring(0, hateoasHref.lastIndexOf('/'));
    return href.substring(href.lastIndexOf('/') + 1);
}

function extractIdFromHateoasModel(hateoasModel) {
    if (hateoasModel._links) {
        return extractIdFromHateoasHref(hateoasModel._links.self.href);
    }
    return null;
}

function fetchReference(hateoasModule, referenceName, href, superAgent) {
    return superAgent.get(href).then(function (response) {
        var value = void 0;
        var rawModel = response.body;

        if (rawModel._embedded) {
            // multiply relation
            value = _underscore2.default.map(extractCollectionFromEmbedded(rawModel), function (collectionItem) {
                hateoasModule.getCache().addRawModelIfPossible(collectionItem); // optimization
                return extractIdFromHateoasModel(collectionItem);
            });
        } else {
            // unary relation
            hateoasModule.getCache().addRawModelIfPossible(rawModel); // optimization
            value = extractIdFromHateoasModel(rawModel);
        }
        return {
            referenceName: referenceName,
            value: value
        };
    }).catch(function (error) {
        if (error.status === 404) {
            return {
                referenceName: referenceName,
                value: null
            };
        }

        throw new Error(error);
    });
}

/**
 * filter self links and self projection links
 */
function extractRelationsLinks(links) {
    var selfHref = links.self.href;
    var filteredLinkNames = _underscore2.default.filter(_underscore2.default.keys(links), function (linkName) {
        var link = links[linkName];
        return link.href !== selfHref && link.href.indexOf('{') < 0;
    });

    var result = {};
    _underscore2.default.each(filteredLinkNames, function (linkName) {
        result[linkName] = links[linkName];
    });

    return result;
}

/**
 * return links, that not present in rawModel body as simple fields (hateoas-enhancements optimisation)
 */
function extractNotFetchedLinks(rawModel, links) {
    var result = {};

    _underscore2.default.forEach(_underscore2.default.keys(links), function (linkName) {
        if (rawModel[linkName] !== undefined) {
            return;
        }

        result[linkName] = links[linkName];
    });

    return result;
}

function extractModelReferences(hateoasModule, model, links, superAgent) {
    if (!links) {
        return _bluebird.Promise.resolve(model);
    }
    var filteredLinks = extractRelationsLinks(links);
    var notFetchedLinks = extractNotFetchedLinks(model, filteredLinks);

    var referencesPromises = _underscore2.default.map(_underscore2.default.keys(notFetchedLinks), function (linkName) {
        var link = notFetchedLinks[linkName];

        return fetchReference(hateoasModule, linkName, link.href, superAgent);
    });

    return _bluebird.Promise.all(referencesPromises).then(function (references) {
        _underscore2.default.each(references, function (reference) {
            model[reference.referenceName] = reference.value;
        });
        return model;
    });
}

function extractModelTypeFromHateoasModel(hateoasModel) {
    return extractModelTypeFromHateoasHref(hateoasModel._links.self.href);
}

/**
 * set correct model id & relations
 * @param {Domain} hateoasModule
 * @param rawHateoasModel
 * @param superAgent
 */
function normalizeModel(hateoasModule, rawHateoasModel, superAgent) {
    var model = _underscore2.default.clone(rawHateoasModel);
    model.id = extractIdFromHateoasModel(rawHateoasModel);
    var links = model._links;
    delete model._links;

    if (!model.id && rawHateoasModel.id) {
        model.id = rawHateoasModel.id;
    }
    return extractModelReferences(hateoasModule, model, links, superAgent);
}

/**
 * Deep update model fields from fresh response. Don't update reference links
 */
function updateModel(model, rawModel) {
    Object.keys(rawModel).forEach(function (key) {
        if (key === '_links') {
            return;
        }
        if (Array.isArray(rawModel[key])) {
            if (model[key] && model[key].length && model[key].models) {
                rawModel[key].forEach(function (item, i) {
                    return updateModel(model[key].models[i], item);
                });
            } else {
                model[key] = rawModel[key];
            }
            return;
        }
        if (rawModel[key] && _typeof(rawModel[key]) === 'object') {
            model[key] = model[key] || {};
            updateModel(model[key], rawModel[key]);
            return;
        }
        model[key] = rawModel[key];
    });
}

function normalizeModels(hateoasModule, hateoasType, hateoasResponse, superAgent) {
    var originalModels = extractCollectionFromEmbedded(hateoasResponse);
    var modelsPromises = _underscore2.default.map(originalModels, function (hateoasModel) {
        var modelId = extractIdFromHateoasModel(hateoasModel);
        var model = hateoasModule.getCache().getEntityIfPresent(hateoasType, modelId);
        if (model) {
            updateModel(model, hateoasModel);
            return new _bluebird.Promise(function (resolve) {
                return resolve(model);
            });
        }

        return normalizeModel(hateoasModule, hateoasModel, superAgent);
    });

    return _bluebird.Promise.all(modelsPromises);
}

function simpleModel2Json(model) {
    var result = void 0;
    try {
        result = JSON.parse(model.toJSON());
        // when embedded entities attached to hateoas-model `id` attribute doesn't present on server side
        // by backbone has this attribute by default
        delete result.id;
    } catch (e) {
        result = model;
    }
    return result;
}

/**
 * if simple model contains complex model, this method helps serialize it correctly
 * @param model - simple model
 */
function convertModel2Json(model) {
    var result = {};
    _underscore2.default.each(_underscore2.default.keys(model.attributes), function (attributeName) {
        var attributeValue = model[attributeName];

        if (attributeValue === null || attributeValue === undefined) {
            result[attributeName] = null;
            return;
        }

        if (attributeName === 'id') {
            // skip id
            return;
        }

        // reference
        if (attributeValue.domain) {
            // todo: check with instanceOf
            var value = attributeValue.domain._idToLink(attributeValue.id, attributeValue.hateoasType);
            result[attributeName] = value;
            return;
        }

        // collection
        if ((0, _nestedUtils.isCollection)(attributeValue)) {
            var _value = attributeValue.models.map(function (collectionModel) {
                if (attributeValue.model.domain) {
                    return attributeValue.model.domain._idToLink(collectionModel.id, attributeValue.model.hateoasType);
                }

                return simpleModel2Json(collectionModel);
            });
            result[attributeName] = _value;
            return;
        }

        // model
        if (attributeValue.toJSON) {
            result[attributeName] = simpleModel2Json(attributeValue);
            return;
        }

        result[attributeName] = attributeValue;
    });

    return JSON.stringify(result);
}

/**
 * hack for jquery
 */
function promise2jqueryPromise(promise) {
    if (!promise.always) {
        promise.always = function () {
            return promise;
        };
    }

    if (!promise.abort) {
        promise.abort = function () {
            return promise;
        };
    }

    return promise;
}

function checkHttpCode(superAgentResponse) {
    if (superAgentResponse.status < 200 || superAgentResponse >= 400) {
        throw superAgentResponse;
    }

    return superAgentResponse;
}

function always(promise, fun) {
    return promise.then(function onSuccess() {
        return fun();
    }, function onError() {
        return fun();
    });
}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/nested-hateoas/dist/utils.js
// module id = 345
// module chunks = 118